// extracted by mini-css-extract-plugin
module.exports = {"panel":"RefinementSalesOffersList_panel__0pwZC","disclaimer":"RefinementSalesOffersList_disclaimer__NAkPn","allRow":"RefinementSalesOffersList_allRow__xgtUy"};